import {observer} from "mobx-react-lite";

export default observer;